import React, { FC } from 'react';
import Title, { TitleProps } from 'antd/es/typography/Title';

type TCustomTitle = TitleProps & React.RefAttributes<HTMLElement>;
const CustomTitle: FC<TCustomTitle> = ({ className, ...props }) => {
  return <Title {...props} style={{ fontSize: 'clamp(22px, 3vw, 32px)' }} />;
};

export default CustomTitle;
